import * as angular from 'angular';

export function goAriaPressedLegacyDirective (): angular.IDirective {
	return {
		restrict: 'A',
		link (scope, element, attrs) {
			scope.$watch(attrs.goAriaPressed, (value) => {
				element.attr('aria-pressed', String(value === true));
			});
		}
	};
}
